import { createElement, Fragment, memo } from 'react';
import { NavLink } from 'react-router-dom';

import clsx from 'clsx';
import { useAtomValue } from 'jotai';
import { isNonNullish } from 'remeda';

import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';

import { FadedMenuItem } from './fadedMenuItem/FadedMenuItem';

import css from './SideBar.module.css';

import { userAtom } from 'v2/atoms/userAtom';
import { DESKTOP_VIEW } from 'v2/constants';
import { NAVIGATION_ITEMS } from 'v2/constants/navigationItems';
import { isRouteAllowed } from 'v2/utils';

export const SideBar = memo(() => {
  const isDesktop = useMediaQuery(`(min-width: ${DESKTOP_VIEW}px)`);

  const user = useAtomValue(userAtom);

  if (!isDesktop) {
    return null;
  }

  return (
    user && (
      <nav className={clsx(css.sideBar, 'scrollbar-hidden')}>
        {NAVIGATION_ITEMS.map((n) =>
          isNonNullish(n.children) ? (
            <FadedMenuItem key={n.title} navigationItem={n} userRoles={user.roles} />
          ) : (
            <Fragment key={n.title}>
              {isRouteAllowed(user.roles, n.group) && (
                <Tooltip title={n.title} slotProps={{ tooltip: { className: css.sideBarTooltip } }} placement="right">
                  <div>
                    <NavLink
                      className={({ isActive }) => clsx(css.sideBarItem, isActive && css.active)}
                      to={n.path ?? ''}
                    >
                      {createElement(n.icon, { className: css.sideBarItemIcon })}
                    </NavLink>
                  </div>
                </Tooltip>
              )}
            </Fragment>
          )
        )}
      </nav>
    )
  );
});

SideBar.displayName = 'SideBar';
